import { useEffect, useState } from 'react';

import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';
import { useUserId } from 'src/core/modules/app/hooks/useUserId';
import { getUserAuthenticationFactors } from 'src/core/modules/authentication-factor/api/getUserAuthenticationFactors';
import { logger } from 'src/utils/datadog-log-wrapper';

import { type AuthenticationFactor } from '../models/factors';

export const useGetUserFactors = () => {
  const [userAuthenticationFactors, setUserAuthenticationFactors] = useState<
    Array<AuthenticationFactor>
  >([]);
  const userId = useUserId();
  const companyId = useCompanyId();

  useEffect(() => {
    const retrieveUserAuthenticationFactors = async () => {
      try {
        const { factors } = await getUserAuthenticationFactors({
          companyId,
          userId,
        });
        setUserAuthenticationFactors(factors);
      } catch (error) {
        logger.error('Error fetching user authentication factors', {
          error,
          scope: 'use-get-user-factors-hook',
          team: 'cards-ux',
        });
      }
    };

    retrieveUserAuthenticationFactors();
  }, []);

  return userAuthenticationFactors
    .filter((f) => !f.isDefault)
    .filter((f) => f.type !== 'EMAIL');
};
